import { Component, computed, input, output } from '@angular/core';
import { UwIcon } from '../icon/uw-icon';

@Component({
  selector: 'uw-chip',
  standalone: true,
  imports: [UwIcon],
  template: `
    <button
      [class]="classes()"
      [attr.aria-pressed]="active()"
      [attr.type]="type()"
      (click)="clicked.emit($event)"
    >
      @if (icon()) {
        <uw-icon [name]="icon()" [size]="13" />
      }
      <ng-content />
      @if (count()) {
        <span class="rounded-full bg-current/10 px-1.5 text-[10px] font-semibold">{{ count() }}</span>
      }
    </button>
  `,
})
export class UwChip {
  readonly active = input(false);
  readonly icon = input<string>('');
  readonly count = input<number | null>(null);
  readonly type = input<'button' | 'submit'>('button');

  readonly clicked = output<MouseEvent>();

  protected readonly classes = computed(() =>
    [
      'inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1 text-[11.5px] font-medium transition-colors cursor-pointer border',
      this.active()
        ? 'bg-primary text-white border-primary shadow-sm'
        : 'bg-surface text-secondary border-line-strong hover:border-text-muted hover:text-primary',
    ].join(' '),
  );
}
